var $11784a3485a38a3c$exports = {};
$11784a3485a38a3c$exports = {
    "colorFormat": `\u{984F}\u{8272}\u{683C}\u{5F0F}`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$11784a3485a38a3c$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
